<template>
  <card>
    <template slot="header">
      <h3 class="card-title">Notice for Approval</h3>
    </template>
    <nav class="row">
      <ol class="breadcrumb arr-right bg-breadcrum">
        <li class="breadcrumb-item">
          <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link to="/hr/nterequest">NTE Tracker</router-link>
        </li>
        <li class="breadcrumb-item active">Notice for Approval</li>
      </ol>
    </nav>
    <hr style="margin-top:-10px" />
    <div class="report-container">
      <div class="row">
        <div class="col-md-12">
          <b-alert show dismissible v-if="item.asm_status == 'approved'">
            <strong>{{ item.requested_by | capitalize}}</strong> - Request NTE to <b>{{item.full_name | capitalize}}</b>, {{item.infraction}}
          </b-alert>
        </div>
      </div>
      <img width="190" height="110" src="/static/img/blueprintlogo.png" alt="..." /><br/>
      <br/>
      <div class="col-md-12 report-border-full">
        <span class="report-header-nte">NOTICE TO EXPLAIN</span>
      </div>
      <div class="report-gatter"></div>
      <div class="col-md-12 report-border-full">
        <div class="row">
          <div class="col-md-4 b-right">
            <b>Employee Name:</b> {{item.full_name | capitalize}}
            <br/>
            <b>Supervisor Name: </b>{{item.superior_name}}
            <br/>
          </div>
          <div class="col-md-4 b-right">
            <b>Date Notice: </b>{{getDate(item.date_incident)}}
            <br/>
            <b>Position:</b> {{item.position_name}}
          </div>
          <div class="col-md-4">
            <b>ID No. : </b>{{item.emp_no}}
            <br/>
          </div>
        </div>
      </div>
      <form @submit.prevent="update_form">
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
          <b>Type of Infraction:</b>
          <!-- <textarea rows="5" class="form-control" v-model="item.type_of_infraction"></textarea><br/> -->
          <br/>{{item.type_of_infraction}}
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
          <b>Details of Occurence:</b>
          <span v-for="(res,i) in item.occurence">
          <br/><b>{{i+1}}</b>.&nbsp;&nbsp;{{res.date}} &nbsp;&nbsp; {{res.details}}
          </span>
          <br/><br/>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
          <b>Details of Infraction:</b><br/>
          <!-- <textarea rows="5" class="form-control" v-model="item.infraction_description"></textarea><br/> -->
          <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.details_of_infraction}}</pre>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
          <b>Corrective Action to be Taken</b>
          <select class="form-control" v-model="corrective">
            <option value="">--Select One --</option>
            <option value="nte">Notice To Explain</option>
            <option value="suspension">Suspension</option>
            <option value="others">Others</option>
          </select>
          <br/>
        </div>
        <div v-if="corrective == 'nte'">
          <font color="red">Select one for your employee action</font>
          <div class="col-md-12 report-border-full">
            <div class="col-md-12 report-border-full">
              <input type="radio" v-model="corection_plan" value="VW - Verbal Warning"> VW - Verbal Warning
              <input type="radio" v-model="corection_plan" value="NTE 1"> NTE 1
              <input type="radio" v-model="corection_plan" value="NTE 2"> NTE 2
              <input type="radio" v-model="corection_plan" value="NTE 3"> NTE 3
            </div>
          </div>
        </div>
        <div v-if="corrective == 'suspension'">
          <font color="red">Select one for your employee action</font>
          <div class="col-md-12 report-border-full">
            <div class="col-md-12 report-border-full">
              <input type="radio" v-model="corection_plan" value="3 Days Suspension"> 3 Days Suspension
              <input type="radio" v-model="corection_plan" value="10 Days Suspension"> 10 Days Suspension
              <input type="radio" v-model="corection_plan" value="15 Days Suspension"> 15 Days Supension
            </div>
          </div>
        </div>
        <div v-if="corrective == 'others'">
          <font color="red">Select one for your employee action</font>
          <div class="col-md-12 report-border-full">
            <input type="radio" v-model="corection_plan" value="Dismissal"> Dismissal
          </div>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
          <div class="form-group">
            <b>HR Approval: </b>
            <select class="form-control" v-model="item.hr_status">
              <option disabled value="">-- Please select one --</option>
              <option value="approved">Approve Request</option>
              <option value="rejected">Decline Request</option>
              <option value="pending">Pending Request</option>
            </select>
          </div>
        </div>
        <br>
        <b>FILE ATTACHMENT</b>
        <br><br>
          <!--FILE PREVIEW -->
          <div class="row col-md-12">
                <div class="upload-btn-wrapper ">
                      <div v-for="(file,key) in item.data_files" :key="key" class="mb-2">
                        <slot v-if="file.file_type == 'vnd.ms-excel'">
                          <i class="fa fa-file-excel-o fa-2x" style="color:green"></i>
                      </slot>
                      <!--// Existing file from database-->
                      <slot v-else-if="file.file_type =='jpeg'">
                          <i class="fa fa-file-image-o fa-2x"></i>
                      </slot> 
                      <slot v-else-if="file.file_type == 'jpg'">
                          <i class="fa fa-file-image-o fa-2x"></i>
                      </slot> 
                      <slot v-else-if="file.file_type == 'png'">
                          <i class="fa fa-file-image-o fa-2x"></i>
                      </slot> 
                      <slot v-else-if="file.file_type == 'docx'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot> 
                      <slot v-else-if="file.file_type == 'csv'">
                          <i class="fa fa-file-excel-o fa-2x" style="color:green"></i>
                      </slot> 
                      <slot v-else-if="file.file_type == 'text/csv'">
                          <i class="fa fa-file-excel-o fa-2x" style="color:green"></i>
                      </slot> 
                      <slot v-else-if="file.file_type == 'pdf'">
                          <i class="fa fa-file-pdf-o fa-2x" style="color:red"></i>
                      </slot> 
                      <slot v-else-if="file.file_type == 'ms-doc'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot>
                      <slot v-else-if="file.file_type == 'msword'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot>
                      <slot v-else-if="file.file_type == 'doc'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot>
                      <slot v-else-if="file.file_type == 'vnd.openxmlformats-officedocument.wordprocessingml.document'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot>
                         &nbsp;&nbsp; <a :href="'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + file.file_name" target="_blank">{{file.file_name}}</a>
                         <span @click="removeExistingFiles(key)"><i class="fa fa-close" style="color:red;cursor: pointer;"></i></span>
                   </div>
                </div>
               </div>
               <!-- END FILE PREVIEW -->
           <br/>
             <!-- MULTIPLE FILE UPLOAD HERE -->
             <div class="upload-btn-wrapper ">
                <label for="nteFiles" class="custom-file-upload"> <i class="fa fa-upload"></i>Attach Files</label>
                <input type="file" ref="files" id="nteFiles" multiple="multiple" accept=".doc,.docx, .pdf, .jpg, .jpeg, .png, .gif" @change="handleNteFilesUpload"/>  
                <div v-for="(file,key) in nteFiles" :key="key" class="mb-2">
                        <!-- New Added files -->
                        <slot v-if="file.type == 'application/vnd.ms-excel'">
                          <i class="fa fa-file-excel-o fa-2x" style="color:green"></i>
                      </slot> 
                      <slot v-else-if="file.type == 'text/csv'">
                        <i class="fa fa-file-excel-o fa-2x" style="color:green"></i>
                       </slot>
                      <slot v-else-if="file.type == 'application/csv'">
                        <i class="fa fa-file-excel-o fa-2x" style="color:green"></i>
                      </slot>
                      <slot v-else-if="file.type =='image/jpeg'">
                          <i class="fa fa-file-image-o fa-2x"></i>
                      </slot> 
                      <slot v-else-if="file.type == 'image/png'">
                          <i class="fa fa-file-image-o fa-2x"></i>
                      </slot> 
                      <slot v-else-if="file.type == 'application/docx'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot> 
                      <slot v-else-if="file.type == 'application/pdf'">
                          <i class="fa fa-file-pdf-o fa-2x" style="color:red"></i>
                      </slot> 
                      <slot v-else-if="file.type == 'application/ms-doc'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot>
                      <slot v-else-if="file.type == 'application/msword'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot>
                      <slot v-else-if="file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                          <i class="fa fa-file-word-o fa-2x" style="color:blue"></i>
                      </slot>  
                      &nbsp;&nbsp; {{file.name}}
                <span @click="removenteFilesUpload(key)"><i class="fa fa-close" style="color:red;cursor: pointer;"></i></span>
                </div>                                                                  
             </div>
             <!-- END MULTIPLE FILE UPLOAD HERE -->
        <div class="form-group">
          <div class="float-right">
            <br/>
            <br/>
            <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Approval</button>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>
        <br/>
        <br/>
      </form>
      <p>HR FORM NO. 0005</p>
    </div>
  </card>
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
components: {
  Card,
},

data() {
  return {
    //ITEMS
    item: {},
    nteFiles: [],
    files: [],
    files: {},
    corrective: '',
    //INPUT
    corection_plan: '',
    //ERROR_HANDLER
    error_handler: [],
     //LIGHTBOX
     imgs: '', 
     visible: false,
     uploadReady:true


  }
},

mounted: function () {
  this.getItem()
},

methods: {
   //LIGHT BOX
   showSingle(img) {
        this.imgs = window.axios.defaults.baseURL + 'upload/' + img.file_name
        this.show()
      },
       show(){ this.visible = true },
       handleHide(){this.visible = false},
     //END LIGHT BOX

  getItem() {
    axios.get('api/nterequestbyhr/get/' + this.$route.params.id)
    .then(resp => {
      this.item = resp.data;
      console.log(this.item.data_files);
    });
  },

  //FILE UPLOAD
  handleNteFilesUpload() {
    let uploadedNTEFiles = event.target.files;
    if(!uploadedNTEFiles.length)
        return
    for (let i = 0; i < uploadedNTEFiles.length; i++){
            this.nteFiles.push( uploadedNTEFiles[i])
    }
    console.log('response => ', uploadedNTEFiles)
  },

  removenteFilesUpload(key){
      this.nteFiles.splice(key, 1)
      console.log(this.nteFiles)
  },

  removeExistingFiles(key){
      this.item.data_files.splice(key, 1)
      console.log(this.item.data_files)
  },

  update_form(e) {
    e.preventDefault();
    //Form data a files to upload
    let formData = new FormData()

    for (var i = 0; i < this.nteFiles.length; i++) {
          let file = this.nteFiles[i];
          formData.append('files[' + i + ']', file);
    }

    //Additional POST Request
    formData.append('existing_files', JSON.stringify(this.item.data_files))
    formData.append('action_to_be_taken', this.corection_plan)
    formData.append('hr_status', this.item.hr_status)
    
    axios.post('api/nterequest/approval/update/' + this.item.id, formData,{
      headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: "Bearer " + localStorage.getItem("token")
        }
    })
      .then(response => {
        this.$swal({
          type: 'success',
          title: 'NTE Request Send..',
          html: 'NTE Request was<br/> successfully send.<br/><br/><br/><br/>',
          showConfirmButton: false,
          timer: 4000
        })

        this.$router.push({
          name: 'nte-request'
        });
        console.log(response.data)
      })
      .catch(error => {
        console.log(error)
      });
  },
},
computed: {
      imgpreview(){
          let data = window.axios.defaults.baseURL + '/upload/'
          return data
      }
  },

}
</script>
<style>
  input[type="file"] {
        display: none; /* Hide default file input */
    }
    .custom-file-upload {
        display: inline-block;
        background-color: #007bff;
        color: white;
        padding: 10px 15px;
        border-radius: 5px;
        cursor: pointer;
        font-weight: bold;
    }

    .custom-file-upload:hover {
        background-color: #0056b3;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-nte-approval.vue